/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ArticleAddBrand.css';
import cx from 'classnames';
import history from './../../history';



class ArticleAddBrand extends React.Component {
  constructor(props){
     super(props)
     this.state={
        value:'',
        seaCompleteItem:[],
        isFixed:false,
        listIndex: 0,
        seaCompleteItem:[],
        selectIndex: 0,
        mouseLeave:true,
        showInput:true
     }
     this.handleSubmit=this.handleSubmit.bind(this)
     
    this.seaComplete = this.seaComplete.bind(this)
    this.mouseSlect=this.mouseSlect.bind(this)
    this.mouseOnClick=this.mouseOnClick.bind(this)
    this.mouseLeave=this.mouseLeave.bind(this)
    this.mouseEnter=this.mouseEnter.bind(this)
    this.isFocusFalse=this.isFocusFalse.bind(this)
    this.keyDown=this.keyDown.bind(this)
  }

  componentDidMount() {
    if(localStorage.getItem('isExpiered')=='false'&&localStorage.getItem('isLogin')=='true'){
      this.setState({showInput:true})
    }else{
      this.setState({showInput:false})
    }
  }

  seaComplete(e) {
    // console.log(this.state.value)
    this.setState({ value: e.target.value })
    if (e.target.value != '') {

      const url = `/digitalAssets/s?q=${e.target.value}`;
      
        fetch(url).then(response => response.json())
        .then(data => {
          // console.log(data,'搜索数据···················')
          this.setState({
              seaCompleteItem: data.items
          })
        })
        .catch(e => console.log("Oops, error", e))
    }

  }

  mouseEnter=()=>{
    // console.log('进入')
    
    this.setState({mouseLeave:false})
  }
  mouseLeave=()=>{
    // console.log('likai')
    this.setState({mouseLeave:true})
  }

  mouseSlect=(index)=>{
    this.setState({selectIndex:index})
  }

  mouseOnClick=()=>{
    const{seaCompleteItem,selectIndex,value}=this.state
    const {i}=this.props


    if(confirm(`确认添加品牌？  ${seaCompleteItem[selectIndex].name}`)){


    let url=`/digitalAssets/center/article/add_brand?brand_id=${seaCompleteItem[selectIndex].id}&url=${encodeURIComponent(i.url)}&emotion=3&platform=${i.from}&statisDate=${i.statisDate}`
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
        console.log(data,'······修改数据···')
        this.setState({
          value:'',
          seaCompleteItem:[],
          selectIndex: 0,
        })
        // console.log('ss',this.state.commonArticle)
      })
    .catch(e => console.log("Oops, error", e))
    alert('正在添加品牌请稍等3秒')

    this.props.refresh()
    }

  
  }
  
  isFocusFalse=()=> {
    // console.log('失去焦点')
    if(this.state.mouseLeave){
      this.setState({
        seaCompleteItem: []
      })
    }
  
  }
  keyDown=(e)=> {
    
        const { selectIndex, seaCompleteItem, value, } = this.state
        const num =  seaCompleteItem.length-1

        // console.log(value,num,selectIndex,'aaaaaaaaaaaaaaaaaaaaaaaa',e.key,selectIndex<0)
       if(e.key=='ArrowUp'&&seaCompleteItem.length!=0){


            let cc=selectIndex<1?num:selectIndex-1
            this.setState({selectIndex:cc})
       }else if(e.key=='ArrowDown'&&seaCompleteItem.length!=0){

            // this.setState({selectIndex:selectIndex+1,value:items[num]['name']})
            let cc=selectIndex<1?selectIndex+1:selectIndex+1
            this.setState({selectIndex:cc})
      }else if(e.key=='Backspace'&&value.length==1){
          this.setState({seaCompleteItem:[]})

      }
          
    
  }
  

  handleSubmit(e){
    const{seaCompleteItem,selectIndex,value}=this.state
    const {items,battle}=this.props
    // console.log(seaCompleteItem,selectIndex)
    e.preventDefault()




  
  }


  render() {

    const {seaCompleteItem,selectIndex,value,showInput}=this.state
    const {items,battle}=this.props

    return(
      <div className={s.root}>
        {!battle||battle&&showInput?
        
        <div className={s.cardInput}>
              <form onSubmit={this.handleSubmit}>
                <input
                  className={s.addContrast}
                  onChange={this.seaComplete}
                  value={this.state.value}
                  type="text"
                  placeholder="添加品牌"
                  onKeyDown={this.keyDown}
                  onBlur={this.isFocusFalse}
                />
              </form>
                
              <ul className={seaCompleteItem.length == 0 ? s.hide : s.seaItems} 
              onMouseLeave={this.mouseLeave}
              onMouseEnter={this.mouseEnter}
              >
              {/* style={{left:`${items.length==1?'297px':'597px'}`}} */}
              
                {seaCompleteItem
                  .map((item, index) => (
                    <li key={index} className={selectIndex % seaCompleteItem.length == index ? cx(s.seaItem, s.seaAc) : s.seaItem}
                        onMouseEnter={()=>this.mouseSlect(index)}
                        onClick={this.mouseOnClick}
                    >
                      <i><img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`} /></i>
                      {item.name}
                    </li>

                  ))}
              </ul>
              
            </div>
        
        :null}
            

      </div>
    )


   
  }
}

export default withStyles(s)(ArticleAddBrand);



// WEBPACK FOOTER //
// src/components/ArticleAddBrand/ArticleAddBrand.js